// src/redux/mealHistorySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchMealData } from "../Apis/dashboardApis";

export const fetchMealHistory = createAsyncThunk(
  "mealHistory/fetchMealHistory",
  async (limit, { rejectWithValue }) => {
    try {
      const data = await fetchMealData(limit);
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch meal history");
    }
  }
);

const mealHistorySlice = createSlice({
  name: "mealHistory",
  initialState: {
    mealHistory: [],
    loading: false,
    error: null,
    needsRefetch: true, // Add needsRefetch flag
  },
  reducers: {
    setNeedsRefetch: (state, action) => {
      state.needsRefetch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMealHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMealHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.mealHistory = action.payload;
        state.needsRefetch = false; // Reset refetch flag
      })
      .addCase(fetchMealHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setNeedsRefetch } = mealHistorySlice.actions;
export const selectMealHistory = (state) => state.mealHistory;

export default mealHistorySlice.reducer;
